module.exports = __webpack_public_path__ + "static/img/holiday-blackberry_th.927c5e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/holiday-blackberry_th.png
// module id = DyjD
// module chunks = 0